import { useLocation as useLocationOriginal, Location } from 'react-router-dom';

const useLocation = <T>(): { state: T } & Omit<Location, 'state'> => {
  const location = useLocationOriginal();
  const { state } = location;

  return { ...location, state };
};

export default useLocation;
